import Axios from "@/utils/axios.config";

const host = process.env.VUE_APP_APIHOST;

export const sendContact = function (data) {
  return Axios({
    url: `${host}/admin/contact/business`,
    method: "POST",
    data,
  });
};
